/*
EST-004	Enrolado
EST-005	Inactivo
EST-006	Fallecido
EST-007	Suspendido
EST-008	Activo
*/

export const patientStatusCode = {
    Affiliate: { text: 'Afiliado', value: 'EST-001', color: '#004988' },
    Discard: { text: 'Descartar', value: 'EST-002', color: ''},   
    Enroll: { text: 'Enrrolar', value: 'EST-003', color: '' }, 
    Rolled: { text: 'Enrolado', value: 'EST-004', color: '#00b189'},
    Inactive: { text: 'Inactivo', value: 'EST-005', color: 'gray' },
    Deceased: { text: 'Fallecido', value: 'EST-006', color: 'gray' },
    Suspended: { text: 'Suspendido', value: 'EST-007', color: '#ffb600' },
    Active: { text: 'Activo', value: 'EST-008', color: '' },
};

/*
EST-028	Activa
EST-027	Remision
*/

export const comorbilidadesEstatusCode = {
    Activa: { value: "EST-028", color: "gray" },
    Remision: { value: "EST-027", color: "" }
};


/*
EP-01	Activo
EP-02	Suspendido
EP-03	Finalizado
EP-04	Cancelado
EP-02	Suspendido
EP-10   Programado
*/

export const actividadesCode = {
    Activa: { text: "Activo", value: "EP-01"},
    Incompleta: { text: "Suspendido", value: "EP-02"},
    Finalizada: { text: "Finalizado", value: "EP-03"},
    Cancelada: { text: "Cancelado", value: "EP-04"},
    Suspendida: { text: "Suspendido", value: "EP-02"},
    Programado: { text: "Programado", value: "EP-10"},
};


/*
1	Intervencion
2	Citas
*/

export const tipoActividades = {
    Intervencion: { text: "Intervencion", value: "1"},
    Cita: { text: "Cita", value: "2"},
};  


/*
EP-04	Inactivo
EP-01	Activo
EP-02	Suspendido / Eliminado 
EP-03	Finalizado
*/

export const planesCuidadoCode = {
    Inactivo: { text: "Inactivo", value: "EP-04", color: "gray" },
    Activo: { text: "Activo", value: "EP-01", color: "" },
    Suspendido: { text: "Suspendido", value: "EP-02", color: "gray" },
    Finalizado: { text: "Finalizado", value: "EP-03", color: "" },
    Eliminado: { text: "Eliminado", value: "EP-02", color: "" },
};


/*
P-003	Mensual
P-004	Trimestral
*/

export const perioricidadCode = {
    Mensual: { text: "Mensual", value: "P-003", color: "gray" },
    Trimestral: { text: "Trimestral", value: "P-004", color: "" }
};
  
/*
GEN-	General     Se utiliza para modulo soporte
ACT-	Actividad
CMB-	Comorbilidad
MED-	Medicamento
RCC-	ResultadoClinico
EVENT-	Eventos
*/

export const procedenciasCode = {
    General: { text: "GEN-", value: "GEN-", color: "gray" },
    Actividad: { text: "ACT-", value: "ACT-", color: "" },
    Comorbilidad: { text: "CMB-", value: "CMB-", color: "" },
    Medicamento: { text: "MED-", value: "MED-", color: "" },
    ResultadoClinico: { text: "RCC-", value: "RCC-", color: "" },
    Eventos: { text: "EVENT-", value: "EVENT-", color: "" }
};
  


  